// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__1f7IV","footer":"NavbarSimple_footer__hI-+m","link":"NavbarSimple_link__sascU","linkIcon":"NavbarSimple_linkIcon__YC+-N"};